import ModalV2 from "./ModalV2";

export default ModalV2;
